import React from "react";
import styles from "./ActionPanel.module.css";
import Input from "@/components/common/input/Input";
import Button from "@/components/common/button/Button";
import type { enhancedControlsProps } from "./types.props";

const ActionPanel: React.FC<enhancedControlsProps> = ({
    placeholder = "Buscar…",
    searchTerm,
    onSearchChange,
    actions,
}) => (
    <div className={styles["controls-container"]}>
        <div className={styles["search-wrapper"]}>
            <Input
                id="search"
                label=""
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                aria-label="Buscar registros"
            />
        </div>
        {actions && actions.length > 0 && (
            <div className={styles["actions-wrapper"]}>
                {actions.map((action) => (
                    <Button
                        key={action.key}
                        variant={action.variant}
                        onClick={action.onClick}
                        disabled={action.disabled}
                        title={action.tooltip}
                    >
                        {action.icon} {action.label}
                    </Button>
                ))}
            </div>
        )}
    </div>
);

export default ActionPanel;
